import { render, staticRenderFns } from "./Manage.vue?vue&type=template&id=f4b798da&scoped=true"
import script from "./Manage.vue?vue&type=script&lang=js"
export * from "./Manage.vue?vue&type=script&lang=js"
import style0 from "./Manage.vue?vue&type=style&index=0&id=f4b798da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b798da",
  null
  
)

export default component.exports